import type { LoaderFunction } from 'react-router-dom';
import { apiListBeltsV2 } from "../../api/beltApi";
import { combineAdminLoader } from "./AdminRouteProtection";

const BeltHandlerLoaderInternal: LoaderFunction = async () => {
    try {
        const response = await apiListBeltsV2();
        return response;
    } catch (error) {
        throw new Error('Failed to load belts');
    }
};

// Wrapper con protezione admin
export const BeltHandlerLoader: LoaderFunction = combineAdminLoader(BeltHandlerLoaderInternal);
